import { render } from "./DatePicker.vue?vue&type=template&id=8b5bb10e&scoped=true"
import script from "./DatePicker.vue?vue&type=script&lang=ts"
export * from "./DatePicker.vue?vue&type=script&lang=ts"

import "./DatePicker.vue?vue&type=style&index=0&id=8b5bb10e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8b5bb10e"

export default script